export const sponsorWebsites = {
    stockedge: 'https://stockedge.com',
    stockgro: 'https://stockgro.club',
    notion: 'https://notion.so',
    finlatics: 'https://finlatics.com',
    bazarville: 'https://bazarville.com',
    unstop: 'https://unstop.com',
    bluelearn: 'https://bluelearn.in',
    giveMyCertificate: 'https://givemycertificate.com',
    internshala: 'https://internshala.com',
    interviewBuddy: 'https://interviewbuddy.in',
    noticebard: 'https://noticebard.com',
    startupTalky: 'https://startuptalky.com',
}